/* eslint-disable react-hooks/rules-of-hooks */
import { useCartState } from 'app/store/cart/state';
export const selectCartData = () => useCartState((state) => state.cartData);
export const selectIsGettingCart= () => useCartState((state) => state.isLoading);
export const selectIsUpdatingCart= () => useCartState((state) => state.isUpdating);